import { render, staticRenderFns } from "./addNewUser.vue?vue&type=template&id=d6f5ea18&"
import script from "./addNewUser.vue?vue&type=script&lang=js&"
export * from "./addNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports